export const THEME_OPTIONS = {
  PURPLE: 'theme-purple',
  BLUE: 'theme-blue',
  GREEN: 'theme-green',
  ORANGE: 'theme-orange',
  GOLD: 'theme-gold',
} as const

export type ThemeVariant = (typeof THEME_OPTIONS)[keyof typeof THEME_OPTIONS]

export const THEME_MODE_OPTIONS = ['light', 'dark', 'system'] as const
export type ModeVariant = (typeof THEME_MODE_OPTIONS)[number]

// O index.html sai com as mesmas classes, para a primeira pintura não piscar.
export const THEME_DEFAULTS = {
  themeColor: 'theme-gold' as ThemeVariant,
  themeMode: 'light' as ModeVariant,
  transitionDuration: 150,
}

export const THEME_STORAGE_KEYS = {
  themeColor: 'bia-theme-color',
  themeMode: 'bia-theme-mode',
}
